import type { ComponentType } from 'react';
import Home from '@/pages/Home/Home';
import Products from '@/pages/Products/Products';
import Technology from '@/pages/Technology/Technology';
import OurStory from '@/pages/OurStory/OurStory';
import Contact from '@/pages/Contact/Contact';
import PatientCare from '@/pages/PatientCare/PatientCare';
import Privacy from '@/pages/Privacy/Privacy';

export interface RouteDefinition {
  path: string;
  label: string;
  showInNav: boolean;
  Component: ComponentType;
}

export const routes: RouteDefinition[] = [
  {
    path: '/',
    label: 'Home',
    showInNav: true,
    Component: Home,
  },
  {
    path: '/products',
    label: 'Products',
    showInNav: true,
    Component: Products,
  },
  {
    path: '/technology',
    label: 'Technology',
    showInNav: true,
    Component: Technology,
  },
  {
    path: '/our-story',
    label: 'Our Story',
    showInNav: true,
    Component: OurStory,
  },
  {
    path: '/contact',
    label: 'Contact Us',
    showInNav: true,
    Component: Contact,
  },
  {
    path: '/patient-care',
    label: 'Patient care',
    showInNav: false,
    Component: PatientCare,
  },
  {
    path: '/legal/privacy',
    label: 'Privacy Policy',
    showInNav: false,
    Component: Privacy,
  },
];

export { default as NotFoundPage } from '@/pages/NotFound/NotFound';
